import {$} from '@/facade'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {TWalletInvocationBuilder} from '@/model/wallets/types/WalletTypes'
import {N3InvocationBuilder} from '@/model/wallets/invocationsBuilder/N3InvocationBuilder'
import {n3NeolineInvocationBuilder} from '@/model/wallets/invocationsBuilder/N3NeolineInvocationBuilder'
import {n3NeonWalletInvocationBuilder} from '@/model/wallets/invocationsBuilder/N3NeonWalletInvocationBuilder'
import {NeoXInvocationBuilder} from '@/model/wallets/invocationsBuilder/NeoXInvocationBuilder'
import {neoXNeonWalletInvocationBuilder} from '@/model/wallets/invocationsBuilder/NeoXNeonWalletInvocationBuilder'
import {neoXNeolineInvocationBuilder} from '@/model/wallets/invocationsBuilder/NeoXNeolineInvocationBuilder'

const walletInvocationBuildersByWalletImplementation: TWalletInvocationBuilder = {
  n3: {
    [WalletPlatform.NEON]: n3NeonWalletInvocationBuilder,
    [WalletPlatform.NEOLINE]: n3NeolineInvocationBuilder,
    [WalletPlatform.ONEGATE]: n3NeonWalletInvocationBuilder,
  },
  neoX: {
    [WalletPlatform.NEON]: neoXNeonWalletInvocationBuilder,
    [WalletPlatform.NEOLINE]: neoXNeolineInvocationBuilder,
    [WalletPlatform.ONEGATE]: neoXNeonWalletInvocationBuilder,
    [WalletPlatform.METAMASK]: neoXNeolineInvocationBuilder,
  },
}

const getCurrentWalletInvocationBuilder = (
  walletImplementation: 'n3' | 'neoX',
  walletPlatform: WalletPlatform
) => {
  const invocationBuilder =
    walletInvocationBuildersByWalletImplementation[walletImplementation][
      walletPlatform
    ]

  if (!invocationBuilder) {
    throw new Error(
      `${walletPlatform} has no ${walletImplementation} invocation builder`
    )
  }

  return invocationBuilder
}

export const getN3InvocationBuilder = (network?: TWalletNetwork) => {
  const walletPlatform = $.walletAdapter.session('n3', network)
    .connectedWalletPlatform

  if (!walletPlatform) {
    throw new Error('N3 wallet is not connected')
  }

  return getCurrentWalletInvocationBuilder(
    'n3',
    walletPlatform
  ) as N3InvocationBuilder
}

export const getXInvocationBuilder = (network?: TWalletNetwork) => {
  const walletPlatform = $.walletAdapter.session('neoX', network)
    .connectedWalletPlatform

  if (!walletPlatform) {
    throw new Error('NeoX wallet is not connected')
  }

  return getCurrentWalletInvocationBuilder(
    'neoX',
    walletPlatform
  ) as NeoXInvocationBuilder
}
